import { useContext, useState } from "react";
import { Button, Modal, Form } from "antd";
import SweetAlert2 from "react-sweetalert2";
import { AuthContext } from "../../../contexts/AuthContext";
import postDataGate from "../../../services/postDataGate";

export default function CloseGatepass({
  isVisible,
  setVisible,
  refetch,
  gatepass,
}: any) {
  const { auth } = useContext(AuthContext);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [swalProps, setSwalProps] = useState({});
  const [form] = Form.useForm();

  const onSubmit = async () => {
    setLoading(true);
    const data = {};
    const uri = `api/gatepass/${gatepass?._id}/close`;
    const response = await postDataGate({ data, uri, token: auth?._id });
    if (response.success) {
      setSwalProps({
        show: true,
        title: "Closed",
        text: "Gatepass Closed Successfully",
        icon: "success",
      });
      await refetch();
      setVisible(false);
      await refetch();
      setLoading(false);
    } else {
      setSwalProps({
        show: true,
        title: "Sorry",
        text: "Something went wrong",
        icon: "error",
      });
      await refetch();
      setVisible(false);
      setLoading(false);
      setSwalProps({});
    }
    setVisible(false);
    setLoading(false);
  };

  const hideModal = async () => {
    setVisible(false);
  };

  return (
    <Modal
      open={isVisible}
      title="Close Gatepass"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={hideModal}>
          No
        </Button>,
        <Button
          key="submit"
          form="closeGate"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Yes
        </Button>,
      ]}
    >
      <Form id="closeGate" form={form} onFinish={onSubmit} layout="vertical">
        <div className="px-4">
          <p>Are you sure you want to close this gatepass ?</p>
        </div>
      </Form>

      <SweetAlert2
        {...swalProps}
        confirmButtonColor="#E50000"
        customClass={{ confirmButton: "#e50000" }}
      />
    </Modal>
  );
}
